import useFieldArray from './useFieldArray';
function FieldArray({ name, validate, children: renderFn }) {
    var _a;
    const fieldArray = useFieldArray(name, { validate });
    return (_a = renderFn === null || renderFn === void 0 ? void 0 : renderFn(fieldArray)) !== null && _a !== void 0 ? _a : null;
}
export default FieldArray;
